import { HttpClient } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { api } from '../URL/api-url';

@Component({
  selector: 'app-welcome-bar',
  templateUrl: './welcome-bar.component.html',
  styleUrls: ['./welcome-bar.component.css']
})
export class WelcomeBarComponent {

  loginTime:any;
  customerName:any;
  changepasswordform: FormGroup = new FormGroup({
    oldpassword: new FormControl(''),
    newpassword: new FormControl(''),
    confirmpassword: new FormControl(''),
  });
  formConfiguration: any;
  lang: any = {};
  selectedLanguage:any;
  lang1: any = {};
  constructor(private formBuilder: FormBuilder, private http: HttpClient) {}
  ngOnInit(): void {
    this.getFormConfiguration('en');
    this.getLanguageTokens()
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.getFuseBill();
    this.loginTime = sessionStorage.getItem('loginTime');
    this.customerName = sessionStorage.getItem('customerName');
    this.changepasswordform = this.formBuilder.group(
      {
        oldpassword: ['',[Validators.required, Validators.minLength(8), Validators.maxLength(40)]],
        newpassword: ['',[Validators.required, Validators.minLength(8), Validators.maxLength(40)]],
        confirmpassword: ['',[Validators.required, Validators.minLength(8), Validators.maxLength(40)]]},
      {
        validator: this.ConfirmedValidator('newpassword', 'confirmpassword'),
      }
    );
  }

  getFormConfiguration(lang: any) {
  }

  public getLanguageTokens(){
    let body= {
      "project":"Member Portal",
      "url":"Sidebar"
    }
    this.http
    .post(api.lang + 'string/project-url-strings',body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .subscribe(
      (response: any) => {
        console.log(response)
        this.lang = {};
        this.selectedLanguage = sessionStorage.getItem('language')||'English'
        for (let token of response.strings) {
          this.lang[token.key] = token[this.selectedLanguage];
        }
        console.log(this.lang)
      }
    )
  }

  changepassword(){
    $("#changepassword").show()
    this.changepasswordform.reset()
    this.changepasswordform.get('oldpassword')?.reset();
  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  logout() {
    sessionStorage.clear();
  }


}
